import { createFileRoute } from '@tanstack/react-router'
import { CrosspostingPlaceTools } from '~/features/crossposting/components/crossposting-place-tools'

export const Route = createFileRoute('/dashboard/crossposting/$listingId/')({
  component: PlaceToolsRoute,
})

function PlaceToolsRoute() {
  const { listingId } = Route.useParams()
  return <CrosspostingPlaceTools listingId={listingId} />
}
